function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("clipPath", {
  id: "b"
}, React.createElement("rect", {
  width: 48,
  height: 48
})));

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  id: "a",
  clipPath: "url(#b)"
}, React.createElement("path", {
  d: "M4.275,9.99a1.285,1.285,0,0,0-.9,2.206L18.8,27.614a1.285,1.285,0,0,0,1.817,0L36.032,12.2a1.285,1.285,0,1,0-1.817-1.817L19.705,24.889,5.2,10.379a1.285,1.285,0,0,0-.921-.389Z",
  transform: "translate(35.99 4.01) rotate(90)"
}), React.createElement("path", {
  d: "M4.275,9.99a1.285,1.285,0,0,0-.9,2.206L18.8,27.614a1.285,1.285,0,0,0,1.817,0L36.032,12.2a1.285,1.285,0,1,0-1.817-1.817L19.705,24.889,5.2,10.379a1.285,1.285,0,0,0-.921-.389Z",
  transform: "translate(47.99 4.01) rotate(90)"
}));

var SvgChevronLeftDouble = function SvgChevronLeftDouble(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgChevronLeftDouble, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Chevron Left Double.d105be5c.svg";
export { ForwardRef as ReactComponent };